import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "flex flex-col mt-4" }
const _hoisted_2 = { class: "col-span-full" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col mt-4"
}
const _hoisted_4 = { class: "text-right col-span-full" }
const _hoisted_5 = { class: "flex justify-start items-start my-4" }
const _hoisted_6 = { class: "flex flex-col mt-4 overflow-hidden" }
const _hoisted_7 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_8 = { class: "inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8" }
const _hoisted_9 = { class: "overflow-hidden border-b border-gray-200 shadow sm:rounded-lg" }
const _hoisted_10 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_11 = { class: "bg-gray-50" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
}, " 日付 ", -1)
const _hoisted_13 = {
  key: 0,
  scope: "col",
  class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
}, " 報酬額 ", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
}, " 税額 ", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-xs font-medium tracking-wider text-left text-gray-500 uppercase"
}, " 報酬額(税込) ", -1)
const _hoisted_17 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_18 = { class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap" }
const _hoisted_19 = {
  key: 0,
  class: "px-6 py-4 text-sm text-gray-500 whitespace-nowrap"
}
const _hoisted_20 = { class: "px-6 py-4 text-sm text-right text-gray-500 whitespace-nowrap" }
const _hoisted_21 = { class: "px-6 py-4 text-sm text-right text-gray-500 whitespace-nowrap" }
const _hoisted_22 = { class: "px-6 py-4 text-sm text-right text-gray-500 whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("select", {
          class: "px-3 py-2 focus:outline-none border-gray-200 rounded dark:placeholder-gray-400 h-9 border bg-white dark:bg-gray-800",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selected_ym) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ym, (i) => {
            return (_openBlock(), _createElementBlock("option", { key: i }, _toDisplayString(i), 1))
          }), 128))
        ], 512), [
          [_vModelSelect, _ctx.selected_ym]
        ])
      ])
    ]),
    (_ctx.selected_tab == 'staff')
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("a", {
              class: "px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md shadow-sm bg-color-3 hover:bg-color-3 focus:outline-none focus:ring-3 focus:ring-offset-3 focus:ring-color-3",
              onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.downloadCsv && _ctx.downloadCsv(...args)), ["prevent"]))
            }, " CSVダウンロード ")
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_5, [
      _createElementVNode("li", {
        class: _normalizeClass(["cursor-pointer py-2 px-4 text-gray-500 border-b-8 border-gray-500 w-1/2 text-center mx-1", _ctx.selected_tab === 'salon' ? 'text-color-3 border-color-3' : '']),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeTab('salon'))),
        "x-text": "tab"
      }, " サロン ", 2),
      _createElementVNode("li", {
        class: _normalizeClass(["cursor-pointer py-2 px-4 text-gray-500 border-b-8 border-gray-500 w-1/2 text-center mx-1", _ctx.selected_tab === 'staff' ? 'text-color-3 border-color-3' : '']),
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeTab('staff'))),
        "x-text": "tab"
      }, " スタッフ ", 2)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("thead", _hoisted_11, [
                _createElementVNode("tr", null, [
                  _hoisted_12,
                  (_ctx.selected_tab == 'staff')
                    ? (_openBlock(), _createElementBlock("th", _hoisted_13, " 名前 "))
                    : _createCommentVNode("", true),
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16
                ])
              ]),
              _createElementVNode("tbody", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.affeliates, (affeliate) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: affeliate.id
                  }, [
                    _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.formatYmd(affeliate.ymd, "MM月DD日")), 1),
                    (_ctx.selected_tab == 'staff')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(affeliate.target_name), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_20, " ¥" + _toDisplayString(affeliate.price), 1),
                    _createElementVNode("td", _hoisted_21, " ¥" + _toDisplayString(affeliate.tax), 1),
                    _createElementVNode("td", _hoisted_22, " ¥" + _toDisplayString(affeliate.price + affeliate.tax), 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}